import { getScoreLetterFromScore } from '@/domain/impact-calculate/utils/get-score-letter-from-score';
import { CalculateFestivalEnv } from '@/domain/impact-calculate-festival/entities/calculate-festival-env.entity';

import { CalculateFestivalEnvDto } from './dto.type';

export class CalculateFestivalEnvMapper {
  static dtoToEntity(dto: CalculateFestivalEnvDto): CalculateFestivalEnv {
    return {
      scoreLetter: getScoreLetterFromScore(dto.score / dto.maxScore),
      score: dto.score,
      maxScore: dto.maxScore,
      topics: {
        GLOBAL_CO2: {
          score: dto.topics.GLOBAL_CO2.score,
          maxScore: dto.topics.GLOBAL_CO2.maxScore,
          sections: {
            CO2: {
              score: dto.topics.GLOBAL_CO2.sections.CO2.score,
              maxScore: dto.topics.GLOBAL_CO2.sections.CO2.maxScore,
            },
          },
        },
        FOOD_BEVERAGES: {
          score: dto.topics.FOOD_BEVERAGES.score,
          maxScore: dto.topics.FOOD_BEVERAGES.maxScore,
          sections: {
            CATERING: {
              score: dto.topics.FOOD_BEVERAGES.sections.CATERING.score,
              maxScore: dto.topics.FOOD_BEVERAGES.sections.CATERING.maxScore,
            },
            BEVERAGES: {
              score: dto.topics.FOOD_BEVERAGES.sections.BEVERAGES.score,
              maxScore: dto.topics.FOOD_BEVERAGES.sections.BEVERAGES.maxScore,
            },
            DISHES: {
              score: dto.topics.FOOD_BEVERAGES.sections.DISHES.score,
              maxScore: dto.topics.FOOD_BEVERAGES.sections.DISHES.maxScore,
            },
          },
        },
        RESOURCES_POLLUTION: {
          score: dto.topics.RESOURCES_POLLUTION.score,
          maxScore: dto.topics.RESOURCES_POLLUTION.maxScore,
          sections: {
            WATER: {
              score: dto.topics.RESOURCES_POLLUTION.sections.WATER.score,
              maxScore: dto.topics.RESOURCES_POLLUTION.sections.WATER.maxScore,
            },
            ENERGY: {
              score: dto.topics.RESOURCES_POLLUTION.sections.ENERGY.score,
              maxScore: dto.topics.RESOURCES_POLLUTION.sections.ENERGY.maxScore,
            },
            WASTE_ECODESIGN: {
              score:
                dto.topics.RESOURCES_POLLUTION.sections.WASTE_ECODESIGN.score,
              maxScore:
                dto.topics.RESOURCES_POLLUTION.sections.WASTE_ECODESIGN
                  .maxScore,
            },
            POLLUTION_LOCATION: {
              score:
                dto.topics.RESOURCES_POLLUTION.sections.POLLUTION_LOCATION
                  .score,
              maxScore:
                dto.topics.RESOURCES_POLLUTION.sections.POLLUTION_LOCATION
                  .maxScore,
            },
          },
        },
        COMMUNICATION: {
          score: dto.topics.COMMUNICATION.score,
          maxScore: dto.topics.COMMUNICATION.maxScore,
          sections: {
            PHYSICAL_COMMUNICATION: {
              score:
                dto.topics.COMMUNICATION.sections.PHYSICAL_COMMUNICATION.score,
              maxScore:
                dto.topics.COMMUNICATION.sections.PHYSICAL_COMMUNICATION
                  .maxScore,
            },
            DIGITAL_COMMUNICATION: {
              score:
                dto.topics.COMMUNICATION.sections.DIGITAL_COMMUNICATION.score,
              maxScore:
                dto.topics.COMMUNICATION.sections.DIGITAL_COMMUNICATION
                  .maxScore,
            },
          },
        },
        PUBLIC_ENGAGEMENT: {
          score: dto.topics.PUBLIC_ENGAGEMENT.score,
          maxScore: dto.topics.PUBLIC_ENGAGEMENT.maxScore,
          sections: {
            MOBILITY_STRATEGY: {
              score:
                dto.topics.PUBLIC_ENGAGEMENT.sections.MOBILITY_STRATEGY.score,
              maxScore:
                dto.topics.PUBLIC_ENGAGEMENT.sections.MOBILITY_STRATEGY
                  .maxScore,
            },
            PUBLIC_INFORMATION: {
              score:
                dto.topics.PUBLIC_ENGAGEMENT.sections.PUBLIC_INFORMATION.score,
              maxScore:
                dto.topics.PUBLIC_ENGAGEMENT.sections.PUBLIC_INFORMATION
                  .maxScore,
            },
          },
        },
      },
      sectors: {
        ANY: {
          score: 0,
          maxScore: 0,
        },
        ARTISTS: {
          score: dto.sectors.artists.score,
          maxScore: dto.sectors.artists.maxScore,
        },
        PUBLIC: {
          score: dto.sectors.public.score,
          maxScore: dto.sectors.public.maxScore,
        },
        SITE: {
          score: dto.sectors.site.score,
          maxScore: dto.sectors.site.maxScore,
        },
        TEAM: {
          score: dto.sectors.team.score,
          maxScore: dto.sectors.team.maxScore,
        },
      },
    };
  }
}
